export const searchPlaceholder = {
  ios: 'Search for your app by name or by its App Store ID (e.g., 469960709).',
  android: 'Search for your app by name or by its Google Play store ID (e.g., com.ea.gp.bej3).',
  windows: 'Search for your app by its Microsoft Store ID (e.g., 9nblggh5142x).',
  amazon: 'Search for your app by its Amazon Appstore ID (e.g., B00EDTSKLU).',
};

export default {};
